import React from "react";

const Privacy = () => {
  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h1 style={styles.heading}>Privacy Policy</h1>
        <p style={styles.lastUpdated}>Last updated: August 11, 2026</p>

        <p style={styles.paragraph}>
          Woolley_Tech ("we", "us", or "our") respects your privacy. This
          Privacy Policy explains how we collect, use, disclose, and safeguard
          your information when you visit our website or use our services.
        </p>

        <h2 style={styles.subheading}>1. Information We Collect</h2>
        <p style={styles.paragraph}>
          We may collect the following types of information:
        </p>
        <ul style={styles.list}>
          <li style={styles.listItem}>
            <strong>Contact information</strong> you provide, such as your name,
            email address, phone number, and message when you contact us or
            subscribe to our newsletter.
          </li>
          <li style={styles.listItem}>
            <strong>Usage data</strong> such as your IP address, browser type,
            pages visited, and time spent on the website, collected automatically.
          </li>
        </ul>

        <h2 style={styles.subheading}>2. How We Use Your Information</h2>
        <p style={styles.paragraph}>We use the information we collect to:</p>
        <ul style={styles.list}>
          <li style={styles.listItem}>Respond to your inquiries and messages.</li>
          <li style={styles.listItem}>Provide and improve our services.</li>
          <li style={styles.listItem}>Send newsletters and updates, if you have opted in.</li>
          <li style={styles.listItem}>Analyze website usage to improve user experience.</li>
        </ul>

        <h2 style={styles.subheading}>3. Cookies</h2>
        <p style={styles.paragraph}>
          Our website may use cookies and similar technologies to enhance your
          browsing experience. You can instruct your browser to refuse all
          cookies or to alert you when a cookie is being sent. However, some
          parts of the website may not function properly without cookies.
        </p>

        <h2 style={styles.subheading}>4. Sharing of Information</h2>
        <p style={styles.paragraph}>
          We do not sell, trade, or rent your personal information to third
          parties. We may share your information only with trusted service
          providers who assist us in operating our website and delivering
          services, or when required to do so by law.
        </p>

        <h2 style={styles.subheading}>5. Data Security</h2>
        <p style={styles.paragraph}>
          We take reasonable measures to protect your personal information from
          unauthorized access, use, alteration, or disclosure. However, no
          method of transmission over the internet or electronic storage is
          100% secure, and we cannot guarantee absolute security.
        </p>

        <h2 style={styles.subheading}>6. Your Rights</h2>
        <p style={styles.paragraph}>
          You have the right to access, correct, update, or delete your personal
          information at any time. You may also opt out of receiving marketing
          communications from us. To exercise any of these rights, please
          contact us using the details below.
        </p>

        <h2 style={styles.subheading}>7. Third-Party Links</h2>
        <p style={styles.paragraph}>
          Our website may contain links to third-party websites. We are not
          responsible for the privacy practices of these websites and encourage
          you to review their privacy policies.
        </p>

        <h2 style={styles.subheading}>8. Changes to This Privacy Policy</h2>
        <p style={styles.paragraph}>
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated "Last updated" date. Your
          continued use of the website after changes are posted constitutes
          acceptance of the revised policy.
        </p>

        <h2 style={styles.subheading}>9. Contact Us</h2>
        <p style={styles.paragraph}>
          If you have any questions about this Privacy Policy or how we handle
          your data, please contact us at{" "}
          <a href="mailto:woolleysamuel06@gmail.com" style={styles.link}>
            woolleysamuel06@gmail.com
          </a>{" "}
          or call us at{" "}
          <a href="tel:+233203790592" style={styles.link}>
            +233 203 790 592
          </a>
          .
        </p>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: "4rem 2rem",
    background: "linear-gradient(to right, #fafafa, #f0e6da)",
    minHeight: "100vh",
  },
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    background: "#fff",
    padding: "3rem",
    borderRadius: "12px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
  },
  heading: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "#8B4513",
    marginBottom: "0.5rem",
  },
  lastUpdated: {
    fontSize: "0.9rem",
    color: "#888",
    marginBottom: "1.5rem",
  },
  subheading: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    color: "#8B4513",
    marginTop: "2rem",
    marginBottom: "0.75rem",
  },
  paragraph: {
    fontSize: "1rem",
    lineHeight: "1.8",
    color: "#333",
    marginBottom: "1rem",
  },
  list: {
    marginLeft: "1.5rem",
    marginBottom: "1rem",
  },
  listItem: {
    fontSize: "1rem",
    lineHeight: "1.8",
    color: "#333",
    marginBottom: "0.5rem",
  },
  link: {
    color: "#8B4513",
    fontWeight: "bold",
  },
};

export default Privacy;
